import { render, staticRenderFns } from "./BoxList.vue?vue&type=template&id=29a253de&scoped=true&"
import script from "./BoxList.vue?vue&type=script&lang=js&"
export * from "./BoxList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/furnitures.scss?vue&type=style&index=0&id=29a253de&lang=scss&scoped=true&"
import style1 from "./BoxList.vue?vue&type=style&index=1&id=29a253de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a253de",
  null
  
)

export default component.exports